"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
const getCourseEnrollments_1 = require("./getCourseEnrollments");
const getContent_1 = require("./getContent");
function getCourseWorksDoc({ courseId, studentId, assignorId, contentId, domainId, courseWorkId, dueDateBefore }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let courseWorksRef = app_1.app.firestore.collection(`courseWorks`);
            if (courseWorkId) {
                console.log(`Returning courseWork docs for ${courseWorkId}`);
                const courseWorksSnapshot = yield courseWorksRef
                    .doc(courseWorkId)
                    .get();
                const doc = [];
                doc.push(Object.assign({ id: courseWorksSnapshot.id }, courseWorksSnapshot.data()));
                return doc;
            }
            else {
                courseWorksRef = courseWorksRef.where('courseWorkState', '==', identifiers_1.Types.CourseWorkStates.ACTIVE);
                if (studentId) {
                    if (courseId) {
                        // TODO: Add studentID filter here..
                        console.warn('studentId with courseId filter is not implemented yet');
                        courseWorksRef = courseWorksRef.where('courseId', '==', courseId);
                        return yield getCourseWorkDocsFromDB(courseWorksRef);
                    }
                    else {
                        return yield getCourseWorksUsingStudentId(courseWorksRef, { studentId, courseId, assignorId });
                    }
                }
                else {
                    if (domainId) {
                        courseWorksRef = courseWorksRef.where('domainId', '==', domainId);
                    }
                    if (assignorId) {
                        courseWorksRef = courseWorksRef.where('assignorId', '==', assignorId);
                    }
                    if (courseId) {
                        courseWorksRef = courseWorksRef.where('courseId', '==', courseId);
                    }
                    if (contentId) {
                        courseWorksRef = courseWorksRef.where('contentId', '==', contentId);
                    }
                    if (dueDateBefore) {
                        courseWorksRef = courseWorksRef.where('dueDate', '<=', dueDateBefore);
                    }
                    return yield getCourseWorkDocsFromDB(courseWorksRef);
                }
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = getCourseWorksDoc;
function getCourseWorksUsingStudentId(courseWorksRef, { studentId, courseId, assignorId }) {
    return __awaiter(this, void 0, void 0, function* () {
        let courses = [];
        if (courseId) {
            // use provided course Id
            console.log(`1. courseId passed along with studentId, ${courseId}`);
            courses = [{
                    courseId
                }];
        }
        else {
            // Get all courseEnrollments of the student
            console.log(`1. Getting all courseEnrollments of the student..`);
            courses = yield getCourseEnrollments_1.default({
                userId: studentId,
                role: identifiers_1.Types.UserPermissionRoles.STUDENT
            });
            if (!courses.length) {
                const msg = `No courses for given studentId ${studentId} found..`;
                console.log(msg);
                throw msg;
            }
        }
        // Get all courseWorks of each course
        console.log(`2. Getting courseWorks of each course..`);
        const allCourseWorkDocs = [];
        for (const course of courses) {
            let tempCourseWorkRef = courseWorksRef.where('courseId', '==', course.courseId);
            // add assignorId filter to courses, if provided in params
            if (assignorId) {
                console.log(`assignorId filter applied : ${assignorId}`);
                tempCourseWorkRef = courseWorksRef.where('assignorId', '==', assignorId);
            }
            const courseWorkDocs = yield getCourseWorkDocsFromDB(tempCourseWorkRef);
            allCourseWorkDocs.push(...courseWorkDocs);
        }
        return allCourseWorkDocs;
    });
}
function getCourseWorkDocsFromDB(courseWorksRef) {
    return __awaiter(this, void 0, void 0, function* () {
        const querySnapshot = yield courseWorksRef.get();
        const docs = [];
        for (const doc of querySnapshot.docs) {
            const { contentId } = doc.data();
            const contentDocs = yield getContent_1.default({ contentIds: [contentId] });
            docs.push(Object.assign({ id: doc.id }, doc.data(), { contentJSON: contentDocs[0] }));
        }
        return docs;
    });
}
//# sourceMappingURL=getCourseWorks.js.map